import { render, staticRenderFns } from "./horarios-acesso-editor.vue?vue&type=template&id=78b98b66&scoped=true"
import script from "./horarios-acesso-editor.vue?vue&type=script&lang=js"
export * from "./horarios-acesso-editor.vue?vue&type=script&lang=js"
import style0 from "./horarios-acesso-editor.vue?vue&type=style&index=0&id=78b98b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b98b66",
  null
  
)

export default component.exports